import React from 'react'
import { Link } from 'react-router-dom'
import { Text } from 'components/base'
import RoutesHelper from 'helpers/RoutesHelper'
import { NoteIcon } from 'components/Utils/Icons'
import AnalyticsTable from '../components/AnalyticsTable'
import providesOrganizationAnalytics from '../dataSync/providesOrganizationAnalytics'
import { getPopularNotesQuery } from 'remote/analytics'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

function PopularAnalytics({
  analytics: { popularNotes = [] },
  analyticsFetchState: { loading },
}) {
  return (
    <section style={{ width: 300, height: 460 }}>
      <Text.Subtitle className="margin-bottom-large">Docs</Text.Subtitle>
      <Text.Callout className="uppercase margin-bottom-medium">
        Popular
      </Text.Callout>

      <AnalyticsTable
        loading={loading}
        title="Doc"
        secondaryTitle="Views"
        entries={popularNotes}
        renderRow={entry => {
          return (
            <TooltipOnHover
              placement="top"
              disabled={!entry.note.title}
              tooltipContent={entry.note.title}
            >
              <Link
                className="font-weight-medium pointer entity-highlight font-size-large flexbox flexbox-align-center padding-horizontal-smaller"
                to={RoutesHelper.noteShow({
                  noteId: entry.note.id,
                })}
              >
                <NoteIcon size={12} style={{ flexShrink: 0 }} />
                <span className="margin-left-smaller ellipsis">
                  {entry.note.title || 'Untitled'}
                </span>
              </Link>
            </TooltipOnHover>
          )
        }}
        renderValue={entry => {
          return entry.count
        }}
      />
    </section>
  )
}

export default providesOrganizationAnalytics(getPopularNotesQuery)(
  PopularAnalytics
)
